exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn-new {\r\n  border-radius: 5px;\r\n  padding: 15px 25px;\r\n  font-size: 22px;\r\n  text-decoration: none;\r\n  margin: 20px;\r\n  color: #fff;\r\n  position: relative;\r\n  display: inline-block;\n}\n.btn-new:active {\r\n  transform: translate(0px, 5px);\r\n  -webkit-transform: translate(0px, 5px);\r\n  box-shadow: 0px 1px 0px 0px;\n}\n.purple {\r\n  background-color: #9b59b6;\r\n  box-shadow: 0px 5px 0px 0px #82409d;\n}\n.purple:hover {\r\n  background-color: #b573d0;\n}\n.orange {\r\n  background-color: #e67e22;\r\n  box-shadow: 0px 5px 0px 0px #cd6509;\n}\n.orange:hover {\r\n  background-color: #ff983c;\n}\r\n", ""]);

// exports
